import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-dialog',
  styleUrls: ['./confirmation-dialog.component.scss'],
  templateUrl: './confirmation-dialog.component.html',
  imports: [
    FormsModule
  ]
})
export class ConfirmationDialogComponent {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  hotname: string;

  constructor(private activeModal: NgbActiveModal) {}

  public decline() {
    this.activeModal.dismiss();
    this.activeModal.close(false);
    return false;
  }

  public accept() {
    this.activeModal.close({hotname: this.hotname, accept: true});
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

}
